import classNames from 'classnames';
import IconButton from 'components/common/IconButton';
import { ProjectWizardContext } from 'context/Context';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const FooterWizard = () => {
  const { step, setStep, setAction, yupSubmitRef, status } =
    useContext(ProjectWizardContext);

  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleExitWithoutSave = () => {
    navigate('/emprendimientos');
  };

  const handleNext = async () => {
    setLoading(true);
    setAction('next');
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      yupSubmitRef.current.click();
    } catch (error) {
      console.error('Error al guardar los datos', error);
    } finally {
      setLoading(false);
    }
  };

  const handleExit = async () => {
    setSaving(true);
    setAction('exit');
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      yupSubmitRef.current.click();
    } catch (error) {
      console.error('Error al guardar y salir', error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '1rem',
          flexWrap: 'wrap',
          justifyContent: 'center'
        }}
      >
        {step > 1 && (
          <IconButton
            variant="light"
            icon="chevron-left"
            onClick={() => {
              if (step > 1) setStep(step - 1);
            }}
          >
            Atrás
          </IconButton>
        )}

        <IconButton
          variant="light"
          icon="xmark"
          onClick={handleExitWithoutSave}
        >
          Salir sin guardar
        </IconButton>

        <IconButton
          variant="outline-primary"
          className={classNames({
            'd-none': step === 1
          })}
          icon="floppy-disk"
          onClick={handleExit}
          disabled={saving}
        >
          {saving ? 'Cargando...' : 'Guardar y salir'}
        </IconButton>

        {(step !== 5 || status !== 'published') && (
          <IconButton
            variant="primary"
            icon={'floppy-disk'}
            onClick={handleNext}
            disabled={loading}
          >
            {loading
              ? 'Cargando...'
              : step !== 5
              ? 'Guardar y seguir'
              : status !== 'published'
              ? 'Publicar aviso'
              : null}
          </IconButton>
        )}
      </div>
    </>
  );
};
